<template>
  <v-container grid-list-md fluid>
    <v-layout align-center justify-space-around wrap>
      <v-flex md12>
        
        <v-toolbar color="primary" dark dense>
          <v-toolbar-title>Devices</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card v-if="device">
          <v-card-title>
            <v-btn text icon color="primary" @click.prevent="openDevicesPage()"> 
              <v-icon dark>arrow_back</v-icon>
            </v-btn>
            <h4> {{ deviceid }} </h4>
            <v-spacer></v-spacer>
            <v-btn small text color="primary" :loading="snack" :disabled="snack || approved" @click.prevent="confirmDelete = true">
              <v-icon dark left>delete</v-icon>
              Delete
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>

          <v-layout wrap>
            <v-flex md6>
              <v-simple-table dense>
                <tbody>
                  <tr>
                    <td>ID</td>
                    <td colspan="2">{{ device.deviceid }}</td>
                  </tr>
                  <tr>
                    <td>Type</td>
                    <td> {{ deviceTypeToString(device.type) }}</td>
                    <td style="text-align: right;">
                      <v-btn x-small text @click.prevent="xkey = 'Type'; tdialog = true" :disabled="approved">
                        <v-icon small>edit</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td>Model</td>
                    <td>{{ device.model }}</td>
                    <td style="text-align: right;">
                      <v-btn x-small text @click.prevent="xkey = 'Model'; xvalue = device.model; xdialog = true" :disabled="approved">
                        <v-icon small>edit</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td>Description</td>
                    <td>{{ device.description }}</td>
                    <td style="text-align: right;">
                      <v-btn x-small text @click.prevent="xkey = 'Description'; xvalue = device.description; xdialog = true" :disabled="approved">
                        <v-icon small>edit</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Template ID</td>
                    <td @click="openTemplatePage(device.templateid)" :style="{cursor:'pointer', color:'#00e', 'text-decoration-line':'underline'}"> {{ device.templateid }}</td>
                    <td style="text-align: right;">
                      <v-btn x-small text @click.prevent="xkey = 'TemplateID'; udialog = true" :disabled="approved">
                        <v-icon small>edit</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td>PostInstall</td>
                    <td colspan="2">{{ filename(device.postinstall) }}</td>
                  </tr>
                  <tr>
                  <tr>
                    <td>Packages</td>
                    <td>{{ prettyPackages(device.packagesList) }}</td>
                    <td style="text-align: right;">
                      <v-btn x-small text @click.prevent="xkey = 'Packages'; xvalue = prettyPackages(device.packagesList); xdialog = true" :disabled="approved">
                        <v-icon small>edit</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td>Owner</td>
                    <td colspan="2">{{ device.owner }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Last Modified</td>
                    <td colspan="2">{{ dateToString(device.lastmodified) }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">Modified By</td>
                    <td colspan="2">{{ device.modifiedby }}</td>
                  </tr>
                  <tr>
                    <td>Approved</td>
                    <td colspan="2">
                      <input type="checkbox" v-model="approved" :loading="snack" :disabled="snack || !aaaaccess(user)" v-on:change="callApproveDevice()">
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-flex>

            <v-flex md6>
              <v-card>
                <!-- <v-card-title>Info</v-card-title> -->
                <v-card-text>
                  <p>
                    <ul>
                      <li>Supported Type is <b>PAC</b> or <b>SCADA</b>.</li>
                      <li>Model is one of the supported PAC/SCADA device models.</li>
                      <li>Packages is a space separated list required for this device.</li>
                      <li>Post Install script will run after template equivalent.</li>
                      <li v-if="aaaaccess(user)">
                        Device files can be found and modified at
                        <a :href="'https://console.cloud.google.com/storage/browser/'+getBucketName()+'/devices/'+deviceid+'/'" target="_blank">gs://{{getBucketName()}}/devices/{{ deviceid }}</a>
                      </li>
                    </ul>
                  </p>
                  <p>
                    Packages for PAC (TEL3 & CPROC) and SCADA (Unity Release) are automatically added. <b class="red--text text--lighten-1">Do not add here, it will break dependencies.</b>
                  </p>
                  <div class="red--text text--lighten-1" v-if="!isDeviceComplete()"> {{ deviceComplete }} </div> <br />
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="xdialog"
      width="500"
      v-if="device"
    >
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-textarea
            v-model="xvalue"
            :label="xkey"
            auto-grow
            solo
            background-color="rgba(0, 0, 0, .02)"
            flat
            counter="4096"
            dense
            :readonly="approved"
            v-if="xkey == 'Packages'"
          ></v-textarea>
          <v-text-field
            v-model="xvalue"
            :label="xkey"
            required
            v-else
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.prevent="xdialog = false">Close</v-btn>
          <v-btn color="primary" text @click.prevent="callUpdateDevice()" :disabled="snack || approved">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="udialog"
      width="500"
      v-if="device"
    >
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="xvalue"
            :items="getTemplates()"
            :loading="isLoading.templates"
            clearable
            label="Templates"
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.prevent="udialog = false">Cancel</v-btn>
          <v-btn color="primary" text @click.prevent="callUpdateDevice()">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="tdialog"
      width="500"
      v-if="device"
    >
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="xvalue"
            :items="getTypes()"
            clearable
            label="Type"
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.prevent="tdialog = false">Cancel</v-btn>
          <v-btn color="primary" text @click.prevent="callUpdateDevice()">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="confirmDelete"
      width="500"
    >
      <v-card>
        <v-card-title>Delete selected device?</v-card-title>
        <v-card-text>
          "{{ deviceid }}" will be deleted. You can't undo this action.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.prevent="confirmDelete = false">Cancel</v-btn>
          <v-btn color="primary" text @click.prevent="callDeleteDevice(); confirmDelete = false">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog"
      persistent
      width="500"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snack"
      :color="snackColor"
      :timeout="snackTimeout"
      :top="true"
    >
      {{ snackMessage }}
      <v-btn
        text
        @click="snack = false"
      >
        <div class="v-menu__content--active" style="display:none; z-index:1000;"></div>
        Close
      </v-btn>
    </v-snackbar>

  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import libvue from '@/lib/vue.js'

export default {
    mixins: [libvue],
    data() {
    return {
      deviceid: this.$route.params.DeviceID,
      confirmDelete: false,
      dialog: false,
      udialog: false,
      tdialog: false,
      xdialog: false,
      xkey: null,
      xvalue: null,
      deviceComplete: "unknown",
      snack: false,
      snackColor: 'primary',
      snackMessage: '',
      snackTimeout: 1000
    }
  },
  components: {},
  mounted() {
  },
  created() {
    this.filterTemplates();
    this.filterDevices();
  },
  computed: {
    device: {
      get() {
        return this.allDevices[this.deviceid];
      }
    },
    approved: {
      get() {
        return this.device.approved;
      },
      set(v) {
        this.device.approved = v;
      },
    },
    ...mapGetters(['allDevices', 'allTemplates', 'user', 'isLoading'])
  },
  methods: {
    openDevicesPage() {
      this.$router.push({ name: 'devices' });
    },
    openTemplatePage(templateid) {
      this.$router.push({ name: 'template-details', params: {TemplateID: templateid} });
    },
    callUpdateDevice() {
      this.dialog = true;
      var t = Object.assign({}, this.device);
        switch (this.xkey) {
          case 'Model':
            t.model = this.xvalue;
            break;
          case 'Description':
            t.description = this.xvalue;
            break;
          case 'TemplateID':
            var rx = /[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}/;
            if (this.xvalue) {
              t.templateid = this.xvalue.match(rx)[0];
            }
            break;
          case 'Type':
            // eslint-disable-next-line no-undef
            if (this.xvalue == this.deviceTypeToString(proto.pb.DeviceType.DEVICEPAC)) {
              // eslint-disable-next-line no-undef
              t.type = proto.pb.DeviceType.DEVICEPAC;
            }
            // eslint-disable-next-line no-undef
            if (this.xvalue == this.deviceTypeToString(proto.pb.DeviceType.DEVICESCADA)) {
              // eslint-disable-next-line no-undef
              t.type = proto.pb.DeviceType.DEVICESCADA;
            }
            break;
          case 'Packages':
            var list = [];
            this.xvalue.split(" ").sort().forEach((v) => {
              list.push(v);
            });
            t.packagesList = [...new Set(list)];
            break;
        }
        this.updateDevice(t).then(() => {
          this.dialog = false;
          this.xdialog = false;
          this.udialog = false;
          this.tdialog = false;
          this.snack = true;
          this.snackColor = 'success';
          this.snackMessage = "Device updated";
          this.filterDevices().then(() => {});
        }).catch((err) => {
          this.dialog = false;
          this.xdialog = false;
          this.udialog = false;
          this.tdialog = false;
          this.snack = true;
          this.snackColor = 'error';
          this.snackMessage = this.errToString(err);
        });
    },
    callDeleteDevice() {
      this.dialog = true;
      var t = Object.assign({}, this.device);
      this.deleteDevice(t).then(() => {
          this.dialog = false;
          this.xdialog = false;
          this.snack = true;
          this.snack = 'success';
          this.snackMessage = "Device deleted";
          this.openDevicesPage();
        }).catch((err) => {
          this.dialog = false;
          this.xdialog = false;
          this.snack = true;
          this.snackColor = 'error';
          this.snackMessage = this.errToString(err);
        });
    },
    callApproveDevice() {
      if (this.approved && !this.isDeviceComplete()) {
        this.snack = true;
        this.snackColor = 'error';
        this.snackMessage = "Device is incomplete";
        this.filterDevices().then(() => {});
        return;
      }
      this.dialog = true;
      var t = Object.assign({}, this.device);
      this.approveDevice(t).then(() => {
          this.dialog = false;
          this.xdialog = false;
          this.snack = true;
          this.snackColor = 'success';
          this.snackMessage = "Device updated";
        }).catch((err) => {
          this.dialog = false;
          this.xdialog = false;
          this.snack = true;
          this.snackColor = 'error';
          this.snackMessage = this.errToString(err);
        });
    },
    getTypes() {
      var types = [];
      // eslint-disable-next-line no-undef
      types.push(this.deviceTypeToString(proto.pb.DeviceType.DEVICEPAC));
      // eslint-disable-next-line no-undef
      types.push(this.deviceTypeToString(proto.pb.DeviceType.DEVICESCADA));
      return types;
    },
    getTemplates() {
      var templates = [];
      Object.values(this.allTemplates).forEach((o) => {
        templates.push(o.templateid + ' [' + this.deviceTypeToString(o.type) + '/' + o.os + '/' + o.baseimage + ']');
        });
      return templates;
    },
    isDeviceComplete() {
      if (!this.device) {
        this.deviceComplete = "No device found";
        return false;
      }
      if (!this.device.templateid || this.device.templateid == "") {
        this.deviceComplete = "Template ID is required";
        return false
      }
      if (!this.device.type || (this.deviceTypeToString(this.device.type) == "None" || this.deviceTypeToString(this.device.type) == "UNKNOWN")) {
        this.deviceComplete = "Device type is required";
        return false
      }
      if (!this.device.model || this.device.model == "") {
        this.deviceComplete = "Model is required";
        return false
      }
      return true;
    },
    ...mapActions(['filterDevices', 'updateDevice', 'deleteDevice', 'approveDevice', 'filterTemplates'])
  }
}
</script>
